export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9516.726d7909.jpg";